import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaGithub, FaEnvelope } from "react-icons/fa";
import SearchBar from "./SearchBar";

export default function NavBar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`sticky top-0 z-50 backdrop-blur-xl transition-colors duration-300 ${
      isScrolled ? 'bg-black/70 border-b border-white/10' : 'bg-transparent border-b border-transparent'
    }`}>
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center gap-6">
        <Link
          to="/"
          className="text-sm font-semibold tracking-tight text-[#f5f5f7] hover:text-white transition-colors whitespace-nowrap"
        >
          Kavi Sekhon
        </Link>

        <div className="flex-1 flex justify-end min-w-0">
          <div className="w-full max-w-xs">
            <SearchBar alwaysVisible={true} />
          </div>
        </div>

        <div className="flex items-center gap-5">
          <a
            href="https://github.com/kavisek"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="text-gray-400 hover:text-white transition-colors"
          >
            <FaGithub className="text-base" />
          </a>
          <a
            href="mailto:info@kavisekhon.com"
            aria-label="Email"
            className="text-gray-400 hover:text-white transition-colors"
          >
            <FaEnvelope className="text-base" />
          </a>
        </div>
      </div>
    </nav>
  );
}
